import { gql } from "@apollo/client";
import { TransferStatus } from "../../types";

export const getTransferBadgeColor = (status: TransferStatus) => {
  const handlers: Record<TransferStatus, string> = {
    [TransferStatus.CONFIRMED]: "green",
    [TransferStatus.FAILED]: "red",
    [TransferStatus.PENDING]: "yellow",
    [TransferStatus.AWAITING_APPROVAL]: "yellow",
    [TransferStatus.QUEUED]: "blue",
    [TransferStatus.REVERSED]: "red",
  };

  return handlers[status] || "gray";
};

export const GET_THIRD_PARTY_PAYOUT = gql`
  query GetThirdPartyIntegratorPayout($id: String!) {
    thirdPartyIntegratorPayout(id: $id) {
      id
      breakdown {
        gross
        net
      }
      override {
        amount
        reason
      }
      thirdPartyIntegrator {
        id
        name
        appId
        webhookUrl
        client {
          id
          userId
          firstName
          lastName
          email
          phoneNumber
          business {
            name
          }
        }
        policy {
          serviceFeeSharePercentage
          remittanceInterval
        }
        paymentProviderInformation {
          defaultAccountNumber
          providerData {
            accountNumber
            providers {
              recipientCode
              providerId
              bankInformation {
                accountName
                accountNumber
                bankName
              }
            }
          }
        }
      }
      orders {
        id
        orderCode
        createdAt
      }
      transfer {
        id
        transferCode
        status
        amount
      }
      payoutPeriodStart
      payoutPeriodEnd
      createdAt
      updatedAt
    }
  }
`;

export const GET_THIRD_PARTY_PAYOUTS = gql`
  query GetThirdPartyIntegratorPayouts($transferStatus: [TransferStatus!]) {
    thirdPartyIntegratorPayouts(transferStatus: $transferStatus) {
      id
      breakdown {
        gross
        net
      }
      thirdPartyIntegrator {
        id
        name
        client {
          firstName
          lastName
          business {
            name
          }
        }
      }
      orders {
        id
        orderCode
      }
      transfer {
        id
        status
      }
      payoutPeriodStart
      payoutPeriodEnd
      createdAt
    }
  }
`;

export const GET_DEFAULT_TRANSFER_RECIPIENT = gql`
  query GetDefaultTransferRecipient($userId: String!) {
    defaultTransferRecipients(userId: $userId) {
      providerId
      bankInformation {
        accountName
        accountNumber
        bankName
      }
    }
  }
`;

export const REVIEW_THIRD_PARTY_PAYOUT = gql`
  mutation ReviewThirdPartyIntegratorPayout(
    $payoutId: String!
    $override: ThirdPartyIntegratorPayoutOverrideInput
  ) {
    reviewThirdPartyIntegratorPayout(payoutId: $payoutId, override: $override) {
      id
      breakdown {
        gross
        net
      }
      override {
        amount
        reason
      }
      transfer {
        id
        status
      }
      updatedAt
    }
  }
`;

export const APPROVE_THIRD_PARTY_PAYOUT = gql`
  mutation ApproveThirdPartyIntegratorPayout(
    $payoutId: String!
    $providerId: String!
  ) {
    approveThirdPartyIntegratorPayout(
      payoutId: $payoutId
      providerId: $providerId
    ) {
      id
      transfer {
        id
        transferCode
      }
    }
  }
`;

export const FINALIZE_THIRD_PARTY_PAYOUT = gql`
  mutation FinalizeThirdPartyIntegratorPayout(
    $payoutId: String!
    $otp: String!
  ) {
    finalizeThirdPartyIntegratorPayout(payoutId: $payoutId, otp: $otp) {
      id
      transfer {
        id
        status
      }
    }
  }
`;

export const CANCEL_TRANSFER_REQUEST = gql`
  mutation CancelTransferRequest($data: CancelTransferRequestInput!) {
    cancelTransferRequest(data: $data) {
      id
      status
    }
  }
`;

export const GET_PAYMENT_PROVIDERS = gql`
  query GetPaymentProviders {
    paymentProviders {
      name
      id
    }
  }
`;
